import React, { Component } from "react";
import { connect } from "react-redux";
import { showInfo, showSuccess } from "../common/iziToast";
import * as Icons from "../common/icons";
import { reduxForm, Field } from "redux-form";
import { subscribeToNewsletter } from "../actions/accountActions";
import FormField from "../components/FormField";
import { required, email } from 'redux-form-validators'
import { utils } from "../common/utils";
import { withTranslation } from 'react-i18next';
import { SitePageContentTypeEnum } from "../common/enums";
import ExtendedLink  from "../components/ExtendedLink";
import { getSiteLinks } from "../actions/supplierActions";

class Footer extends Component {

    onAppLinkClicked = e => {
        const { t } = this.props;
        showInfo(
            t("ENJO App"),
            t("The app is coming soon!"),
            Icons.APP
        );
    };

    subscribeToNewsletterHanlder(values) {
        this.setState({ email: values.email });
        return this.props.subscribeToNewsletter({ email: values.email, shouldSubscribe: true }).then((response) => {
            const { t } = this.props;
            showSuccess(
                t("Newsletter"),
                t("Subscribed successfully"),
                Icons.APP
            );
        }, (error) => {
            console.log(error);
        });
    }

    componentDidMount() {
        this.props.getSiteLinks().then((response) => { }, (error) => { });
    }


    componentDidUpdate(prevProps) {
        const { settings } = this.props;
        if (this.props.locale !== prevProps.locale) // Check if it's a new user, you can also use some unique property, like the ID  (this.props.user.id !== prevProps.user.id)
        {
            this.props.getSiteLinks().then((response) => { }, (error) => { });
        }

        if (window.ga) {
            window.ga('send', 'pageview');
        }
        if (window.gtag) {
            window.gtag('js', new Date());
            window.gtag('config', settings.googleTagManagerId);
        }
    }


    render() {
        const { t, handleSubmit, settings, siteLinks, locale, submitting } = this.props;
        const phoneText = settings.telephone ? (<p className="text-white"> {t("Phone")}: {settings.telephone}</p>) : "";
        let linkIndex = 0;

        const cookieOptIn = settings.showCookieConsent ? (<> | <a type="button" aria-label='{t("Cookie Settings")}' className='view-cookie-setting' data-cc="c-settings">{t("Cookie Settings")}</a></>) : "";

        const localeAccountlinksList = siteLinks && siteLinks.footerAccountLinks ? siteLinks.footerAccountLinks.filter(link => (utils.isNullOrEmpty(link.locale) || link.locale === locale)) : [];
        const footerAccountLinks = localeAccountlinksList.map(link => {
            if (link.contentType === SitePageContentTypeEnum.Url) {

                return (
                    <li key={++linkIndex}>
                        <a rel="noopener noreferrer" className='offcanvas-menu-link' target={link.target}
                            href={utils.getLinkUrl(link, settings)}>{link.name}</a>

                        {/*<ExtendedLink rel="noopener noreferrer" className='offcanvas-menu-link' target={link.target}*/}
                        {/*    to={utils.getLinkUrl(link, settings)}>{link.name}</ExtendedLink>*/}
                    </li>
                );
            } else {
                return (<li key={++linkIndex}>
                    <ExtendedLink className='offcanvas-menu-link'
                        to={`${settings.baseUrl}page/${link.id}`}>{link.name}</ExtendedLink>
                </li>);
            }
        });

        const localeAboutlinksList = siteLinks && siteLinks.footerAboutLinks ? siteLinks.footerAboutLinks.filter(link => (utils.isNullOrEmpty(link.locale) || link.locale === locale)) : [];
        const footerAboutLinks = localeAboutlinksList.map(link => {
            if (link.contentType === SitePageContentTypeEnum.Url) {
                return (
                    <li key={++linkIndex}>
                        <a rel="noopener noreferrer" className='offcanvas-menu-link' target={link.target}
                            href={utils.getLinkUrl(link, settings)}>{link.name}</a>
                    </li>
                );
            } else {
                return (<li key={++linkIndex}>
                    <ExtendedLink className='offcanvas-menu-link'
                        to={`${settings.baseUrl}page/${link.id}`}>{link.name}</ExtendedLink>
                </li>);
            }
        });

        const colSizeClass = footerAboutLinks && footerAboutLinks.length > 0 ? "col-lg-3 col-md-6" : "col-lg-4 col-md-6";
        return (
            <footer className="site-footer">
                <div className="container">
                    <div className="row">
                        <div className={colSizeClass}>
                            {/* <!-- Contact Info--> */}
                            <section className="widget widget-light-skin">
                                <h3 className="widget-title">{t("Get In Touch With Us")}</h3>
                                {phoneText}
                                <ul className="list-unstyled text-sm text-white">
                                    <li>
                                        {settings.weekDaysWorkingHours}
                                    </li>
                                    <li>
                                        {settings.weekEndWorkingHours}
                                    </li>
                                </ul>
                                <p>
                                    <a
                                        className="navi-link-light"
                                        href={`mailto:${settings.email}`}
                                    >
                                        {settings.email}
                                    </a>
                                </p>
                                {settings.facebookUrl &&(<a rel="noopener noreferrer" className="social-button shape-circle sb-facebook sb-light-skin" href={settings.facebookUrl} target="_blank" >
                                    <i className="socicon-facebook" />
                                </a>)}
                                {settings.twitterUrl && (<a rel="noopener noreferrer" className="social-button shape-circle sb-twitter sb-light-skin" href={settings.twitterUrl} target="_blank" >
                                    <i className="socicon-twitter" />
                                </a>)}
                                {settings.instagramUrl &&(<a rel="noopener noreferrer" className="social-button shape-circle sb-instagram sb-light-skin" href={settings.instagramUrl} target="_blank" >
                                    <i className="socicon-instagram" />
                                </a>)}
                                {settings.youtubeUrl && ( <a rel="noopener noreferrer" className="social-button shape-circle sb-youtube sb-light-skin" href={settings.youtubeUrl} target="_blank" >
                                    <i className="socicon-youtube" />
                                </a>)}
                            </section>
                        </div>
                        <div className={colSizeClass}>
                            {/* <!-- Mobile App Buttons--> */}
                            <section className="widget widget-light-skin">
                                <h3 className="widget-title">{t("Our Mobile App")}</h3>
                                <button className="market-button apple-button mb-light-skin" onClick={this.onAppLinkClicked}>
                                    <span className="mb-subtitle">{t("Download on the")}</span>
                                    <span className="mb-title">App Store</span>
                                </button>
                                <button className="market-button google-button mb-light-skin" onClick={this.onAppLinkClicked}>
                                    <span className="mb-subtitle">{t("Download on the")}</span>
                                    <span className="mb-title">Google Play</span>
                                </button>
                                <button  className="market-button windows-button mb-light-skin" onClick={this.onAppLinkClicked}>
                                    <span className="mb-subtitle">{t("Download on the")}</span>
                                    <span className="mb-title">Windows Store</span>
                                </button>


                            </section>
                        </div>
                        
                        {/* <!-- About Us--> */}
                        {footerAboutLinks && footerAboutLinks.length > 0 && (<div className={colSizeClass}>
                            <section className="widget widget-links widget-light-skin">
                                <h3 className="widget-title">{t("About Us")}</h3>
                                <ul>
                                    {footerAboutLinks}
                                </ul>
                            </section> 
                                </div>)}
               
                        <div className={colSizeClass}>
                            {/* <!-- Account / Shipping Info--> */}
                            <section className="widget widget-links widget-light-skin">
                                <h3 className="widget-title">{t("Account & Shipping Info")}</h3>
                                <ul>
                                    {footerAccountLinks}
                                </ul>
                            </section>
                        </div>
                    </div>
                    <hr className="hr-light mt-2 margin-bottom-2x" />
                    <div className="row">
                        <div className="col-md-7 padding-bottom-1x">
                            {/* <!-- Payment Methods--> */}
                            <div className="margin-bottom-1x fixed-max-width">
                                <img src="img/payment_methods.png" alt={t("Payment Methods")} />
                            </div>
                        </div>

                        {settings.showNewsLetterSignup && <div className="col-md-5 padding-bottom-1x">
                            <div className="margin-top-1x hidden-md-up" />
                            {/* <!--Subscription--> */}
                            <form
                                className="subscribe-form"
                                method="post"
                                onSubmit={handleSubmit(this.subscribeToNewsletterHanlder.bind(this))}
                                noValidate
                            >
                                <div className="clearfix">
                                    <div className="input-group input-light">
                                        <Field
                                            className="form-control"
                                            type="email"
                                            name="email"
                                            icon="icon-mail"
                                            component={FormField}
                                            placeholder={t("Your e-mail")}
                                            validate={[required({ msg: t("is required") }), email({ msg: t("is invalid email") })]}
                                        />
                                    </div>
                                    <div className="bot-trick" aria-hidden="true">
                                        <input
                                            type="text"
                                            name="b_c7103e2c981361a6639545bd5_1194bb7544"
                                            tabIndex="-1"
                                        />
                                    </div>
                                    <button className="btn btn-primary" type="submit" disabled={submitting}>
                                        <i className="icon-check" />
                                    </button>
                                </div>
                                <span className="form-text text-sm text-white opacity-50">
                                    {t("Subscribe to our Newsletter to receive early discount offers,latest news, sales and promo information")}
                                </span>

                            </form>

                        </div>}
                    </div>
                    {/* <!-- Copyright--> */}
                    <p className="footer-copyright">
                        © {t("All rights reserved.")}&nbsp; 
                        <a
                            href="http://oskfel.com/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                           {t("Powered by")} Merlin
                        </a> 
                        {cookieOptIn}
                    </p>
                </div>
            </footer>
        );
    }
}

function mapStateToProps({ settings, siteLinks, locale }, ownProps) {
    return { settings, siteLinks, locale,  ...ownProps };
}

Footer = connect(mapStateToProps, { subscribeToNewsletter, getSiteLinks })(Footer)


export default withTranslation()(reduxForm({ form: "subscribe" })(Footer));